import React from "react";
import { BalanceAggregateType } from "./DashboardFinancial";
import gettext from "../../shared/utils/gettext";
import { aggregateNames, getUrl } from "./utils";
import { ButtonGroup, Button } from "react-bootstrap";
interface DashboardFinancialBarProps {
  isSummary: boolean;
  aggregate?: BalanceAggregateType;
  variant?: "financial" | "financialYears";
  className?: string;
  children?: React.ReactNode;
}

const DashboardFinancialBar = ({
  isSummary,
  aggregate,
  variant,
  children,
}: DashboardFinancialBarProps) => (
  <div className="bg-white s-b clearfix p-2">
    <div className="container-fluid p-0">
      <div className="row mx-0">
        <div className="col-12 p-0">
          <Button variant="outline-smoke" href={`#financial/${aggregate}/`} disabled={isSummary}>
            <i className="far fa-arrow-left" /> {gettext("Overview")}
          </Button>
          <ButtonGroup className="mx-2">
            {aggregateNames.map((name, index) => (
              <Button
                variant="outline-smoke"
                disabled={variant === "financialYears" && index > 0}
                key={index}
                href={`#financial/${index}/`}
                className={index === (aggregate || 0) ? "active" : undefined}
              >
                {name}
              </Button>
            ))}
          </ButtonGroup>
          <div className="display-controllers d-inline-block float-right">
            <Button variant="outline-smoke" className="mr-2" href="/cropr/settings/financial/">
              <i className="far fa-cog" /> {gettext("Financial configuration")}
            </Button>
            <Button
              variant="outline-smoke"
              className="mr-2"
              title={gettext("Download")}
              href={getUrl({ aggregate })}
            >
              <i className="far fa-file-excel" /> Excel
            </Button>
          </div>
          {children}
          <Button
            variant="outline-smoke"
            href={variant === "financialYears" ? "#financial/0/" : "#financialYears/0/"}
            className={`ml-2 ${variant === "financialYears" ? "active" : ""}`}
          >
            {gettext("History")}
          </Button>
        </div>
      </div>
    </div>
  </div>
);
export default DashboardFinancialBar;
